<div class="col no-overflow full-width padding all">
  <div class="row padding right">
    <app-structure-card> </app-structure-card>
  </div>
  <div class="row flex-end padding right">
    <div *ngIf="showHideUpgradeStructureButton(structure)">
      <button mat-flat-button (click)="upgradeStructure(structure)">
        <mat-icon class="align-middle" title="Upgrade Structure">upgrade</mat-icon> <span>Upgrade Structure</span>
      </button>
    </div>
    <!-- Feature flag controls WHO can access (role-based), business logic controls WHEN (ownership) -->
    <div *featureFlag="'DELETE_STRUCTURE'">
      <div class="delete-button" >
        <button mat-flat-button (click)="deleteStructure(structure)">
          <mat-icon class="align-middle" title="Delete Structure">delete_outline</mat-icon> <span>Delete Structure</span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="structure" class="row padding right">
    <app-key-system-card [keySystemDataSets]="keySystemDataSets" [keySystem]="keySystem" [structure]="structure">
    </app-key-system-card>
  </div>
  <div class="row padding right">
    <app-add-attachments-card [structure]="structure" [user]="user"></app-add-attachments-card>
  </div>
  <div class="row margin all">
    <mat-card class="notes full-width margin right">
      <mat-card-header class="header-container">
        <mat-card-title>Notes</mat-card-title>
        <div class="row flex-end center">
          <button *ngIf="expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
            <mat-icon fontSet="material-icons-outlined">expand_more</mat-icon>
          </button>
          <button *ngIf="!expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
            <mat-icon fontSet="material-icons-outlined">expand_less</mat-icon>
          </button>
        </div>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content *ngIf="expanded" class="padding lrg all">
        <div class="project-summary">
          <div class="row">
            <p>Select Note Type:</p>
            <div role="radiogroup" aria-label="Note Type selection" class="button-chip-group margin left">
              <button
                type="button"
                class="button-chip"
                [class.active]="noteType === 1"
                role="radio"
                [attr.aria-checked]="noteType === 1"
                (click)="updateNoteType(1)"
              >
                Structure
              </button>

              <button
                type="button"
                class="button-chip"
                [class.active]="noteType === 2"
                role="radio"
                [attr.aria-checked]="noteType === 2"
                (click)="updateNoteType(2)"
              >
                N-Order
              </button>

              <button
                type="button"
                class="button-chip"
                [class.active]="noteType === 3"
                role="radio"
                [attr.aria-checked]="noteType === 3"
                (click)="updateNoteType(3)"
              >
                Bitting List
              </button>

              <button
                type="button"
                class="button-chip"
                [class.active]="noteType === 4"
                role="radio"
                [attr.aria-checked]="noteType === 4"
                (click)="updateNoteType(4)"
              >
                FSIC
              </button>
            </div>
            <!-- <mat-chip-listbox
              class="margin lg left"
              aria-label="Note Type selection"
              [(value)]="noteType"
              (selectionChange)="onNoteTypeChange(noteType)"
            >
              <mat-chip-option class="margin left right pointer" [value]="1">Structure</mat-chip-option>
              <mat-chip-option class="margin left right pointer" [value]="2">N-Order</mat-chip-option>
              <mat-chip-option class="margin left right pointer" [value]="3">Bitting List</mat-chip-option>
            </mat-chip-listbox> -->
          </div>

          <form [formGroup]="noteForm" class="col padding lrg top right left scroll" style="max-height: 70vh">
            <div class="flex flex-row justify-between mt-3 margin top lg" *ngIf="noteType === 3">
              <div class="row">
                <mat-form-field
                  appearance="outline"
                  class="fill flex-auto padding right med-input"
                  floatLabel="always"
                >
                  <mat-label>Date Sent</mat-label>
                  <input
                    matInput
                    formControlName="dateSent"
                    [matDatepicker]="dateSentPicker"
                    placeholder="MM/DD/YYYY"
                    (keyup.enter)="postNote()"
                  />
                  <mat-datepicker-toggle matSuffix [for]="dateSentPicker"> </mat-datepicker-toggle>
                  <mat-datepicker #dateSentPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" class="fill flex-auto padding right med-input" floatLabel="always">
                  <mat-label>Email sent to</mat-label>
                  <input
                    matInput
                    formControlName="email"
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                    (keyup.enter)="postNote()"
                  />
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  class="fill flex-auto mr-3 padding right sml-input"
                  floatLabel="always"
                >
                  <mat-label>Order #</mat-label>
                  <input
                    matInput
                    formControlName="orderNumber"
                    noWhiteSpace
                    maxlength="25"
                    (keyup.enter)="postNote()"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="new-note margin top">
              <textarea
                maxlength="2000"
                #newNote
                (keyup.enter)="postNote()"
                matInput
                formControlName="newNote"
                rows="4"
                placeholder="Begin a new note..."
              >
              </textarea>
              <div class="row flex-end">
                <mat-hint>{{ noteForm.get('newNote').value?.length || 0 }} / 2000</mat-hint>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="flex padding lg bottom">
              <p>Filter Note Type By:</p>
              <mat-chip-listbox class="margin lg left" aria-label="Note Type filter">
                <mat-chip-option
                  class="margin left right pointer"
                  [ngClass]="{
                    selectedNoteType: activeFilterButton === '',
                    nonSelectedNoteType: activeFilterButton !== ''
                  }"
                  (click)="filterTable('')"
                  >All</mat-chip-option
                >
                <mat-chip-option
                  selected
                  class="margin left right pointer"
                  [ngClass]="{
                    selectedNoteType: activeFilterButton === 'Structure',
                    nonSelectedNoteType: activeFilterButton !== 'Structure'
                  }"
                  (click)="filterTable('Structure')"
                  >Structure</mat-chip-option
                >
                <mat-chip-option
                  class="margin left right pointer"
                  [ngClass]="{
                    selectedNoteType: activeFilterButton === 'N-Order',
                    nonSelectedNoteType: activeFilterButton !== 'N-Order'
                  }"
                  (click)="filterTable('N-Order')"
                  >N-Order</mat-chip-option
                >
                <mat-chip-option
                  class="margin left right pointer"
                  [ngClass]="{
                    selectedNoteType: activeFilterButton === 'Bitting List',
                    nonSelectedNoteType: activeFilterButton !== 'Bitting List'
                  }"
                  (click)="filterTable('Bitting List')"
                  >Bitting List</mat-chip-option
                >
                <mat-chip-option
                  class="margin left right pointer"
                  [ngClass]="{
                    selectedNoteType: activeFilterButton === 'FSIC',
                    nonSelectedNoteType: activeFilterButton !== 'FSIC'
                  }"
                  (click)="filterTable('FSIC')"
                  >FSIC</mat-chip-option
                >
              </mat-chip-listbox>
            </div>
          </div>
          <!-- Full notes table -->
          <table mat-table [dataSource]="dataSource" [trackBy]="trackByFn" class="mat-elevation-z2" style="width: 100%;">
            
            <!-- Date Column -->
            <ng-container matColumnDef="modifiedOn">
              <th mat-header-cell *matHeaderCellDef>Created/Last Modified</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.modifiedOn ? (element?.modifiedOn | date: 'M/d/yy h:mma') : (element?.createdOn | date: 'M/d/yy h:mma') }}
              </td>
            </ng-container>

            <!-- Created By Column -->
            <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef>Created By</th>
              <td mat-cell *matCellDef="let element">{{ element?.createdBy }}</td>
            </ng-container>

            <!-- Note Type Column -->
            <ng-container matColumnDef="noteType">
              <th mat-header-cell *matHeaderCellDef>Note Type</th>
              <td mat-cell *matCellDef="let element">{{ element?.noteTypeName }}</td>
            </ng-container>

            <!-- Message Column -->
            <ng-container matColumnDef="message">
              <th mat-header-cell *matHeaderCellDef>Note Description</th>
              <td mat-cell *matCellDef="let element">{{ element?.message }}</td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let element">{{ element?.email }}</td>
            </ng-container>

            <!-- Order Number Column -->
            <ng-container matColumnDef="orderNumber">
              <th mat-header-cell *matHeaderCellDef>Order#</th>
              <td mat-cell *matCellDef="let element" [matTooltip]="element?.orderNumber" matTooltipPosition="right">
                {{ element?.orderNumber }}
              </td>
            </ng-container>

            <!-- Date Sent Column -->
            <ng-container matColumnDef="dateSent">
              <th mat-header-cell *matHeaderCellDef>Date Sent</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.dateSent | date : 'MM/dd/YYYY' }}
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button [disabled]="checkDisable(element)" (click)="editNote(element)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button [disabled]="checkDisable(element)" (click)="deleteNote(element)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Filter Columns -->
            <ng-container matColumnDef="modifiedOn-filter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="padding right margin right">
                  <input matInput placeholder="Search Keywords" class="columnSearch" (keyup)="applyColumnFilter($event, 'modifiedOn')" />
                </div>
              </th>
            </ng-container>

            <ng-container matColumnDef="createdBy-filter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="padding right margin right">
                  <input matInput placeholder="Search Keywords" class="columnSearch" (keyup)="applyColumnFilter($event, 'createdBy')" />
                </div>
              </th>
            </ng-container>

            <ng-container matColumnDef="noteType-filter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="padding right margin right">
                  <input matInput placeholder="Search Keywords" class="columnSearch" (keyup)="applyColumnFilter($event, 'noteType')" />
                </div>
              </th>
            </ng-container>

            <ng-container matColumnDef="message-filter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="padding right margin right">
                  <input matInput placeholder="Search Keywords" class="columnSearch" (keyup)="applyColumnFilter($event, 'message')" />
                </div>
              </th>
            </ng-container>

            <ng-container matColumnDef="email-filter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="padding right margin right">
                  <input matInput placeholder="Search Keywords" class="columnSearch" (keyup)="applyColumnFilter($event, 'email')" />
                </div>
              </th>
            </ng-container>

            <ng-container matColumnDef="orderNumber-filter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="padding right margin right">
                  <input matInput placeholder="Search Keywords" class="columnSearch" (keyup)="applyColumnFilter($event, 'orderNumber')" />
                </div>
              </th>
            </ng-container>

            <ng-container matColumnDef="dateSent-filter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="padding right margin right">
                  <input matInput placeholder="Search Keywords" class="columnSearch" (keyup)="applyColumnFilter($event, 'dateSent')" />
                </div>
              </th>
            </ng-container>

            <ng-container matColumnDef="actions-filter">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="basicDisplayedColumns"></tr>
            <tr mat-header-row *matHeaderRowDef="basicDisplayedColumnFilters"></tr>
            <tr mat-row *matRowDef="let row; columns: basicDisplayedColumns"></tr>
          </table>
          
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
